<div class="footer bg-azul-sunedu2">
  <div
    class="footer-container"
    fxLayout="row wrap"
    fxLayout.xs="column">
    <div
      class="p-25"
      fxFlex="75%"
      fxFlex.lt-md="100%">
      <div class="m-b-10 text-titulo-parrafo-footer font-bold">
        <a
          href="javascript:"
          (click)="handleClickRouteAbout()"
          class="text-titulo-parrafo-footer">
          Acerca de nosotros
        </a>
      </div>
      <div class="m-b-25 text-justify">
        TUNI.PE es una plataforma informática destinada a consolidar y almacenar la información sobre el sistema de educación superior universitaria, la cual es generada por la Superintendencia Nacional de Educación Superior Universitaria en el desarrollo de sus procesos, conforme a las exigencias de la Ley N° 30220, Ley Universitaria y a los lineamientos de la política de aseguramiento de la calidad de la educación superior universitaria.
      </div>

      <div fxLayout="row wrap">
        <div
          class="m-b-25"
          fxFlex="60%"
          fxFlex.lt-md="100%">
          <div class="m-b-10 text-titulo-parrafo-footer font-bold">Contáctanos</div>

          <div
            fxLayout="row"
            fxLayoutAlign="flex-start center">
            <span class="tuni-icono-medium tuni-icono-footer-telefono m-r-15"></span>
            <div class="text-blanco-sunedu">
              <div>
                <span class="font-bold">Central:</span>
                (511)500-3930
              </div>
              <div>
                <span class="font-bold">Horario de atención telefónica:</span>
              </div>
              <div>
                lunes a viernes de 08:30 a. m. a 04:30 p. m.
              </div>
            </div>
          </div>

          <div
            class="m-t-25"
            fxLayout="row"
            fxLayoutAlign="flex-start center">
            <span class="tuni-icono-medium tuni-icono-footer-ubicacion m-r-15"></span>
            <div class="text-blanco-sunedu">
              <div>
                Calle Aldabas N.° 337 – Urb. Las Gardenias.
              </div>
              <div>
                (Cruce Av. Benavides y Av. Caminos del Inca)
              </div>
              <div>Santiago de Surco – Lima</div>
            </div>
          </div>

          <div
            class="m-t-25"
            fxLayout="row"
            fxLayoutAlign="flex-start center">
            <span class="tuni-icono-medium tuni-icono-footer-horario m-r-15"></span>
            <div class="text-blanco-sunedu">
              <div>
                <span class="font-bold">Horario presencial (lunes a viernes)</span>
              </div>
              <div>
                Atención al Ciudadano 08:30 a. m. a 04:30 p. m.
              </div>
              <div>
                Mesa de Partes 08:30 a. m. a 04:30 p. m.
              </div>
            </div>
          </div>

        </div>

        <div
          class="m-b-25"
          fxFlex="40%"
          fxFlex.lt-md="100%">
          <div class="m-b-10 text-titulo-parrafo-footer font-bold">Enlaces de interés</div>

          <div class="m-t-25 m-b-10 text-titulo-parrafo-footer">
            <a
              href="https://enlinea.sunedu.gob.pe"
              class="text-blanco-sunedu no-underline"
              target="_blank">
              Sunedu en línea
            </a>
          </div>

          <div class="m-t-25 m-b-10 text-titulo-parrafo-footer">
            <a
              href="javascript:"
              (click)="handleClickRouteAbout()"
              class="text-blanco-sunedu no-underline">
              Nosotros
            </a>
          </div>

          <div class="m-t-25 m-b-10 text-titulo-parrafo-footer">
            <a
              href="https://www.sunedu.gob.pe/preguntas-frecuentes-tuni/"
              class="text-blanco-sunedu no-underline"
              target="_blank">
              Preguntas frecuentes
            </a>
          </div>

        </div>
      </div>
    </div>

    <div
      class="p-25"
      fxFlex="25%"
      fxFlex.lt-md="100%">
      <div class="p-25">
        <img
          src="https://www.sunedu.gob.pe/wp-content/uploads/2015/09/logo_blanco.png"
          class="imagen-logo-footer"
          alt="logo_blanco">
      </div>
      <div class="text-center">
        <div class="icono-red-social">
          <a
            href="https://www.facebook.com/SuneduPeru"
            target="_blank">
            <!-- <i class="fa fa-facebook"></i> -->
            <img
              src="/assets/img/svg/icono_facebook.svg"
              width="30"
              alt>
          </a>
        </div>
        <div class="icono-red-social">
          <a
            href="https://www.instagram.com/sunedu.peru/"
            target="_blank">
            <!-- <i class="fa fa-instagram"></i> -->
            <img
              src="/assets/img/svg/icono_instagram.svg"
              width="30"
              alt>
          </a>
        </div>
        <div class="icono-red-social">
          <a
            href="https://www.youtube.com/@sunedu_peru"
            target="_blank">
            <!-- <i class="fa fa-twitter"></i> -->
            <img
              src="/assets/img/svg/icono_youtube.svg"
              width="30"
              alt>
          </a>
        </div>
        <div class="icono-red-social">
          <a
            href="https://twitter.com/SuneduPeru"
            target="_blank">
            <!-- <i class="fa fa-twitter"></i> -->
            <img
              src="/assets/img/svg/icono_twitter.svg"
              width="30"
              alt>
          </a>
        </div>
        <div class="icono-red-social">
          <a
            href="https://pe.linkedin.com/company/sunedu"
            target="_blank">
            <!-- <i class="fa fa-linkedin"></i> -->
            <img
              src="/assets/img/svg/icono_linkedin.svg"
              width="30"
              alt>
          </a>
        </div>
        <div class="icono-red-social">
          <a
            href="https://www.tiktok.com/@suneduperu"
            target="_blank">
            <!-- <i class="fa fa-twitter"></i> -->
            <img
              src="/assets/img/svg/icono_tiktok.svg"
              width="30"
              alt>
          </a>
        </div>
      </div>
    </div>
  </div>

</div>
